import { create } from 'zustand'
import { LayoutStore } from './types'

const useStore = create<LayoutStore>( ( set ) => ( {
    Component: null,
    setComponent: ( Component ) => set( { Component } ),

    isMobile: false,
    setIsMobile: ( isMobile ) => set( { isMobile } )
} ) )

export default useStore